module.exports = __webpack_public_path__ + "img/planters-punch.315556f5.jpg";